import React from 'react';
import { ShoppingCart as CartIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { motion } from 'framer-motion';
import { useCart } from '@/contexts/CartContext';
import { useI18n } from '@/contexts/I18nContext';

const cartLabels: Record<string, string> = {
  es: 'Carrito',
  de: 'Warenkorb',
  fr: 'Panier',
  it: 'Carrello',
  pt: 'Carrinho',
  en: 'Cart',
};

export const CartButton: React.FC = () => {
  const { items, setIsOpen } = useCart();
  const { locale } = useI18n();
  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
  const label = cartLabels[locale] || 'Cart';

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="relative"
    >
      <Button
        variant="outline"
        size="sm"
        className="relative h-auto bg-black/[0.04] hover:bg-black/[0.08] border-black/[0.06] hover:border-black/[0.1] text-black/60 hover:text-black backdrop-blur-sm transition-all duration-300 px-3 2xl:px-4 py-1.5 rounded-full whitespace-nowrap text-[13px] 2xl:text-sm font-semibold"
        onClick={() => setIsOpen(true)}
        title={label}
      >
        <CartIcon className="h-3.5 w-3.5 shrink-0" />
        <span className="ml-1.5 hidden 2xl:inline">{label}</span>
        {itemCount > 0 && (
          <Badge 
            variant="destructive" 
            className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center text-xs p-0 bg-primary text-primary-foreground"
          >
            {itemCount}
          </Badge>
        )}
      </Button>
    </motion.div>
  );
};